export default "__VITE_ASSET__DF19ycUd__"